import state from "../state";
import renderBoard from "./renderBoard";
export default function clearBoard(mainCanvas, mainCtx) {
    state.setDrawing(false);
    state.setActiveStroke(null);
    state.setStrokes([]);
    renderBoard(mainCanvas, mainCtx, [], state.getCamera());
}
